import { Hash } from 'lucide-react';
import { FilterStringConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createProductionCodeFilterConfig(): FilterStringConfig {
  return {
    label: 'Code',
    icon: <Hash className="size-4" />,
    type: 'string',
    createDefaultValue: () => ({ operator: 'contains', value: '' }),
    options: {
      placeholder: 'Enter code'
    }
  };
}
